import React, { useEffect, useRef } from 'react';

export default function Modal({ open, title, onClose, children, footer }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && open) {
        onClose?.();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  useEffect(() => {
    if (open && dialogRef.current) {
      const el = dialogRef.current.querySelector('[data-autofocus]');
      if (el) el.focus();
    }
  }, [open]);

  if (!open) return null;

  const backdropStyle = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)',
    backdropFilter: 'blur(2px)', display: 'grid', placeItems: 'center', zIndex: 1000,
    padding: '24px'
  };
  const cardStyle = {
    width: '100%', maxWidth: 720, background: 'rgba(255,255,255,0.98)',
    border: '1px solid rgba(0,0,0,0.08)', borderRadius: 16,
    boxShadow: '0 20px 48px rgba(0,0,0,0.18)', overflow: 'hidden'
  };
  const headerStyle = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '14px 16px', borderBottom: '1px solid rgba(0,0,0,0.06)'
  };
  const bodyStyle = { padding: 16 };
  const footerStyle = {
    display: 'flex', gap: 10, justifyContent: 'flex-end', padding: '12px 16px',
    borderTop: '1px solid rgba(0,0,0,0.06)'
  };

  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div style={backdropStyle} onClick={onBackdropClick} role="presentation">
      <div style={cardStyle} role="dialog" aria-modal="true" aria-labelledby="modal-title" ref={dialogRef}>
        <div style={headerStyle}>
          <h3 id="modal-title" className="section-title" style={{ margin: 0 }}>{title}</h3>
          <button type="button" className="btn btn-pill" onClick={onClose} aria-label="Close" style={{ minWidth: 0 }}>×</button>
        </div>
        <div style={bodyStyle}>{children}</div>
        {footer && <div style={footerStyle}>{footer}</div>}
      </div>
    </div>
  );
}